import React from 'react';
import { motion } from 'framer-motion';
import { FaClock, FaStar, FaBolt } from 'react-icons/fa';

const MobileHUD = ({ score, time, level, combo }) => {
  return (
    <div className="fixed top-0 left-0 w-full p-2 sm:p-3 z-40 pointer-events-none">
      <div className="flex justify-between items-start gap-2">
        {/* Left Side - Timer & Level */}
        <div className="flex flex-col gap-1.5 sm:gap-2">
          <motion.div
            animate={time <= 10 ? { scale: [1, 1.1, 1] } : {}}
            transition={{ duration: 0.5, repeat: time <= 10 ? Infinity : 0 }}
            className={`
              px-2.5 py-1.5 sm:px-3 sm:py-2 rounded-lg sm:rounded-xl shadow-lg 
              flex items-center gap-1.5 sm:gap-2 font-bold
              ${time <= 10 ? 'bg-red-500 text-white' : 'bg-white/90 text-purple-600'}
            `}
          >
            <FaClock size={14} className="sm:w-4 sm:h-4" />
            <span className="text-base sm:text-lg">{time}s</span>
          </motion.div>

          <div className="bg-gradient-to-r from-purple-500 to-indigo-600 text-white px-2.5 py-1 sm:px-3 sm:py-1 rounded-lg sm:rounded-xl shadow-lg text-[10px] sm:text-xs font-bold">
            Lv. {level}
          </div>
        </div>

        {/* Right Side - Score (更窄的設計,避免與控制按鈕重疊) */}
        <motion.div
          key={score}
          initial={{ scale: 1 }}
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ duration: 0.2 }}
          className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-2.5 py-1.5 sm:px-4 sm:py-2 rounded-lg sm:rounded-xl shadow-lg"
        >
          <div className="text-[9px] sm:text-xs uppercase tracking-wide opacity-90 text-center leading-tight">
            分數
          </div>
          <div className="text-lg sm:text-2xl font-black leading-tight">{score}</div>
        </motion.div>
      </div>

      {/* Combo Indicator - 移到下方避免重疊 */}
      {combo > 1 && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="mt-1.5 sm:mt-2 flex justify-center"
        >
          <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1 sm:px-4 sm:py-1.5 rounded-full shadow-lg flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm font-bold">
            <FaBolt className="text-yellow-200 text-xs sm:text-sm" />
            {combo}x 連擊
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default MobileHUD;